const formatPriceType = (type: string): string => type.split("_").pop() ?? type;

const formatPriceAmount = (amount: number): string =>
  amount.toLocaleString("en-US");

export { formatPriceType, formatPriceAmount };
